import React, { PureComponent } from 'react';
import cn from 'classnames';
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import search from "../../img/icons/search-iconic.svg"
import SVGSymbol from "../SVGSymbol"
import { toggleSearchDialog, closeDropdown } from '../../actions'

class SearchIcon extends PureComponent {
  _onSearchClick = () => {
    const { handleSearch } = this.props;
    handleSearch();
  }
  _onSearchHover = () => {
    const {handleClose} = this.props
    handleClose('gender');
  }
  render () {
    const { classes, classNames = {} } = this.props;
    
    return (
      <a
        className={cn(classes.searchLink, classNames.searchLink)}
        onClick={this._onSearchClick}
        onMouseEnter={this._onSearchHover}
        data-ga-category="Header Navigation"
        data-ga-action="Search"
        data-ga-label="Search icon"
      >
        <SVGSymbol className={classes.searchIcon} icon={search} />
      </a>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    
  }
}

function mapDispatchToProps(dispatch) {
  return {
    handleSearch: () => dispatch(toggleSearchDialog()),
    handleClose: ( id ) => dispatch(closeDropdown(id))

  }
}

export default injectSheet((theme) => ({
  searchLink: {
    position: 'relative',
    padding: 12,
    boxSizing: 'content-box',
    color: theme.colors.black,
    width: 16,
    height: 16,
    "&:hover": {
      color: theme.colors.primary,
      [theme.breakpoint("tablet")]: {
        color: 'rgba(70, 70, 70, 1)'
      }
    },
    [theme.breakpoint("tablet")]: {
      color: 'rgba(70, 70, 70, 1)',
    }
  },
  searchIcon: {
    display: 'block',
    width: 16,
    height: 16,
  },
}))(connect(mapStateToProps, mapDispatchToProps)(SearchIcon))



// WEBPACK FOOTER //
// ./src/components/UniversalNav/SearchIcon.js